export default function Footer() {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-slate-900 via-slate-800 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12 sm:py-16 lg:py-20">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 lg:gap-12 mb-10 sm:mb-12 lg:mb-16">
          {/* Company Info */}
          <div className="sm:col-span-2 lg:col-span-1">
            <h3 className="text-2xl sm:text-3xl font-bold mb-3 sm:mb-4 bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent">
              Outsmarwebs
            </h3>
            <p className="text-sm sm:text-base text-gray-300 leading-relaxed mb-4 sm:mb-6">
              Professional website design for small and medium businesses. Affordable, modern, and results-driven.
            </p>
            <div className="flex gap-3">
              {[
                { icon: 'ri-linkedin-fill', color: 'hover:bg-blue-600' },
                { icon: 'ri-twitter-x-fill', color: 'hover:bg-gray-700' },
                { icon: 'ri-instagram-fill', color: 'hover:bg-pink-600' },
                { icon: 'ri-facebook-fill', color: 'hover:bg-blue-500' }
              ].map((social, index) => (
                <a
                  key={index}
                  href="#"
                  className={`w-10 h-10 sm:w-12 sm:h-12 rounded-lg bg-white/10 flex items-center justify-center ${social.color} transition-all cursor-pointer`}
                >
                  <i className={`${social.icon} text-lg sm:text-xl`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-base sm:text-lg font-bold mb-3 sm:mb-4">Quick Links</h4>
            <ul className="space-y-2 sm:space-y-3">
              {[
                { label: 'Home', id: 'home' },
                { label: 'About', id: 'about' },
                { label: 'Services', id: 'services' },
                { label: 'Portfolio', id: 'portfolio' }
              ].map((link, index) => (
                <li key={index}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-sm sm:text-base text-gray-300 hover:text-cyan-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-base sm:text-lg font-bold mb-3 sm:mb-4">Services</h4>
            <ul className="space-y-2 sm:space-y-3">
              {[
                'Business Websites',
                'E-commerce Stores',
                'Landing Pages',
                'Website Redesign'
              ].map((service, index) => (
                <li key={index}>
                  <button
                    onClick={() => scrollToSection('services')}
                    className="text-sm sm:text-base text-gray-300 hover:text-cyan-400 transition-colors cursor-pointer"
                  >
                    {service}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-base sm:text-lg font-bold mb-3 sm:mb-4">Contact</h4>
            <ul className="space-y-3 sm:space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-cyan-400 text-lg sm:text-xl mt-0.5 flex-shrink-0"></i>
                <a href="mailto:info@outsmartwebs.com" className="text-sm sm:text-base text-gray-300 hover:text-cyan-400 transition-colors cursor-pointer break-all">
                  info@outsmartwebs.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-cyan-400 text-lg sm:text-xl mt-0.5 flex-shrink-0"></i>
                <a href="tel:+14317660666" className="text-sm sm:text-base text-gray-300 hover:text-cyan-400 transition-colors cursor-pointer">
                  +1 (431) 766-0666
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-time-line text-cyan-400 text-lg sm:text-xl mt-0.5 flex-shrink-0"></i>
                <span className="text-sm sm:text-base text-gray-300">
                  Mon-Fri: 9AM - 6PM EST
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-6 sm:pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-xs sm:text-sm text-gray-400 text-center sm:text-left">
              © {currentYear} Outsmarwebs. All rights reserved.
            </p>
            <div className="flex flex-wrap justify-center gap-4 sm:gap-6">
              <a href="#" className="text-xs sm:text-sm text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer whitespace-nowrap">
                Privacy Policy
              </a>
              <a href="#" className="text-xs sm:text-sm text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer whitespace-nowrap">
                Terms of Service
              </a>
              <a 
                href="https://readdy.ai/?ref=logo" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-xs sm:text-sm text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer whitespace-nowrap"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
